import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { MessageSquareText } from 'lucide-react'
import { Logo } from '@/components/generals/logo'
import { FeedbackDialog } from '@/components/generals/feedback-dialog'
import { TelegramLink } from '@/components/generals/telegram-link'
import { navLinks } from '@/constants/site'

export const Header: FC = (): ReactNode => {
    return (
        <header className='sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur-lg supports-backdrop-filter:bg-background/70'>
            <div className='mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6'>
                <Logo />

                <nav aria-label='Main' className='hidden items-center gap-1 md:flex'>
                    {navLinks.map((link) => (
                        <Link
                            key={link.href}
                            href={link.href}
                            className='rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors outline-none hover:bg-accent hover:text-accent-foreground focus-visible:ring-4 focus-visible:ring-ring/30'
                        >
                            {link.label}
                        </Link>
                    ))}

                    <FeedbackDialog className='inline-flex cursor-pointer items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors outline-none hover:bg-accent hover:text-accent-foreground focus-visible:ring-4 focus-visible:ring-ring/30'>
                        <MessageSquareText className='size-4' aria-hidden='true' />
                        Feedback
                    </FeedbackDialog>
                </nav>

                <TelegramLink size='sm' className='h-10 px-3.5'>
                    <span className='hidden sm:inline'>
                        Telegram bot
                    </span>

                    <span className='sm:hidden'>
                        Bot
                    </span>
                </TelegramLink>
            </div>
        </header>
    )
}
